<script>

export default
{
    name: 'about-us',

    render () 
    {
        return (
            <div id='about-us-view'>
                <div class='title'>Qui sommes-nous</div>
                <div class='text'>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#about-us-view
{
    width: 100%;
    padding-top: 15vh;

    & .title
    {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 6vw;

        .OnTablet({ font-size: 4.5vw; });
        .OnDesktop({ font-size: 2vw; });
    }

    & .text
    {
        margin-top: 10vh;
        margin-bottom: 10vh;
        width: 90%;
        margin-left: 5%;

        .OnTablet({
            width: 70%;
            margin-left: 15%;
        });

        .OnDesktop({
            width: 60%;
            margin-left: 20%;
        });

        h2
        {
            margin: 2vh 0;
        }

        b
        {
            color: var(--theme-accent-color);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue